import { StepConfig, StepperConfig } from '@mydocma/import-export';

export const step1: StepConfig = {
  name: 'duplicateOptions',
  label: 'MM.fault.duplicate.options.title',
  icon: {
    number: 'toggle_off',
    edit: 'toggle_off',
    done: 'toggle_off'
  },
  optional: false,
  editable: true,
  enabled: true
};

export const step2: StepConfig = {
  name: 'duplicateLocation',
  label: 'MM.fault.duplicate.location.title',
  icon: {
    number: '_stacked-organizational-chart-highlighted-first-node',
    edit: '_stacked-organizational-chart-highlighted-first-node',
    done: '_stacked-organizational-chart-highlighted-first-node'
  },
  optional: false,
  editable: true,
  enabled: true
};

export const step3: StepConfig = {
  name: 'duplicateAttachments',
  label: 'MM.fault.duplicate.attachments.title',
  icon: {
    number: 'attach_file',
    edit: 'attach_file',
    done: 'attach_file'
  },
  optional: false,
  editable: true,
  enabled: true
};

export const faultDuplicateStepperConfig: StepperConfig = {
  steps: [
    step1,
    step2,
    step3
  ]
};